import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/Menu`;

export default {  
    getAll: async () => {
        const requestOptions = {
            method: 'GET',
            headers: await header.authHeaderWithToken(),
        };
    
        let rs = await fetch(`${mainUrl}/GetAll`, requestOptions);
        return await common.handleResponse(rs);
    },

    getAllPaging: async (params) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "currentPage": params.currentPage,
                "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
                "sortBy": (params.sortBy)? params.sortBy: "0",
                "orderDesc": params.sortDesc,
                "searchkey": (params.searchKey)? params.searchKey: ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetAllPaging`, requestOptions);
        return await common.handleResponse(rs);
    },

    getByRoleId: async (roleId) => {
        const requestOptions = {
            method: 'GET',
            headers: await header.authHeaderWithToken(),
        };
    
        let rs = await fetch(`${mainUrl}/GetByRoleId?roleId=${roleId}`, requestOptions);
        return await common.handleResponse(rs);
    },

    getByRoleIds: async (roleIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify(roleIds)
        };
    
        let rs = await fetch(`${mainUrl}/GetByRoleIds`, requestOptions);
        return await common.handleResponse(rs);
    },

    getByRolesAsTree: async (roleIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify(roleIds)
        };
    
        let rs = await fetch(`${mainUrl}/GetByRolesAsTree`, requestOptions);
        return await common.handleResponse(rs);
    },
}